import type { EmployeeProfile } from "@/data/employees";

export function reportingCandidates(employees: EmployeeProfile[], employee: EmployeeProfile) {
  const byId = new Map(employees.map(e => [e.id, e]));
  return employees.filter(candidate => {
    if (candidate.status !== "Active" || candidate.id === employee.id) return false;
    if (employee.mainRole === "hr" && candidate.subRole !== "c_level") return false;
    const seen = new Set<string>();
    let current: EmployeeProfile | undefined = candidate;
    while (current) {
      if (current.id === employee.id || seen.has(current.id)) return false;
      seen.add(current.id);
      current = current.reportsTo ? byId.get(current.reportsTo.id) : undefined;
    }
    return true;
  });
}
